import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { messageEnhancer, toaster } from "../../sharedfiles/helper";
import { boostedOddsApis } from "../../sharedfiles/EndpointConfig";
export const BoostedOddsSlice = createSlice({
    name: "BoostedOddsSlice",
    initialState: {
        sportByBrand: [],
        countryBySport: [],
        leagueBySportCountry: [],
        eventBySportCountryLeague: [],
        marketByEvent: [],
        subMarket: [],
        outComes: [],
        oddsByOutcome: [],
        allBoostedOdds: [],
        viewBoostedOddUser: [],

        paginationFirstValue: 1,
        paginationSecondValue: 25,
        isVisible: false,
        recordToShow: [1, 25],
        totalRecord: '',
        countryInBonus: [],
        countryInBonusPopup: [],
        leaguesInBonus: [],
        eventInBonus: [],
        countries: [],
        leagues: [],
        events: [],
        isCountriesLoading: true,
        isLeagueLoading: true,
        isEventLoading: true,
        onlySportsSelected: false,
        sportsSelectedInDialog: [],
        eventsOpt: [],
        noLeaguesAvailable: true,
        isOddsByOutcomeLoading: false,
        persistedFormData: {},
    },
    reducers: {
        setPersistedFormData: (state, action) => {
            state.persistedFormData = action.payload
        },
        setSportByBrand: (state, action) => {
            state.sportByBrand = action.payload
        },
        setCountryBySport: (state, action) => {
            state.countryBySport = action.payload
        },
        setLeagueBySportCountry: (state, action) => {
            state.leagueBySportCountry = action.payload
        },
        setEventBySportCountryLeague: (state, action) => {
            state.eventBySportCountryLeague = action.payload
        },
        setMarketByEvent: (state, action) => {
            state.marketByEvent = action.payload
        },
        setSubMarket: (state, action) => {
            state.subMarket = action.payload
        },
        setOutComes: (state, action) => {
            state.outComes = action.payload
        },
        setOddsByOutcome: (state, action) => {
            state.oddsByOutcome = action.payload
        },
        setAllBoostedOdds: (state, action) => {
            state.allBoostedOdds = action.payload
        },
        setPaginationFirstValue: (state, action) => {
            state.paginationFirstValue = action.payload
        },
        setPaginationSecondValue: (state, action) => {
            state.paginationSecondValue = action.payload
        },
        setIsVisible: (state, action) => {
            state.isVisible = action.payload
        },
        setRecordToShow: (state, action) => {
            state.recordToShow = action.payload
        },
        setTotalRecord: (state, action) => {
            state.totalRecord = action.payload
        },
        setViewBoostedOddUser: (state, action) => {
            state.viewBoostedOddUser = action.payload
        },
        setLeaguesInBonus: (state, action) => {
            state.leaguesInBonus = action.payload
        },
        setCountryInBonus: (state, action) => {
            state.countryInBonus = action.payload
        },
        setEventInBonus: (state, action) => {
            state.eventInBonus = action.payload
        },
        setCountries: (state, action) => {
            state.countries = action.payload;
        },
        setLeagues: (state, action) => {
            state.leagues = action.payload;
        },
        setEvents: (state, action) => {
            state.events = action.payload;
        },
        setIsCountriesLoading: (state, action) => {
            state.isCountriesLoading = action.payload;
        },
        setIsLeagueLoading: (state, action) => {
            state.isLeagueLoading = action.payload;
        },
        setIsEventLoading: (state, action) => {
            state.isEventLoading = action.payload;
        },
        setCountryInBonusPopup: (state, action) => {
            state.countryInBonusPopup = action.payload;
        },
        setOnlySportsSelected: (state, action) => {
            state.onlySportsSelected = action.payload;
        },
        setSportsSelectedInDialog: (state, action) => {
            state.sportsSelectedInDialog = action.payload;
        },
        setEventsOpt: (state, action) => {
            state.eventsOpt = action.payload;
        },
        setNoLeaguesAvailable: (state, action) => {
            state.noLeaguesAvailable = action.payload;
        },
        setIsOddsByOutcomeLoading: (state, action) => {
            state.isOddsByOutcomeLoading = action.payload;
        }
    }
})

export const {
    setSportByBrand,
    setCountryBySport,
    setLeagueBySportCountry,
    setEventBySportCountryLeague,
    setMarketByEvent,
    setSubMarket,
    setOutComes,
    setOddsByOutcome,
    setAllBoostedOdds,
    setPaginationFirstValue,
    setPaginationSecondValue,
    setIsVisible,
    setRecordToShow,
    setTotalRecord,
    setViewBoostedOddUser,
    setLeaguesInBonus,
    setCountryInBonus,
    setEventInBonus,
    setCountries,
    setLeagues,
    setEvents,
    setIsCountriesLoading,
    setIsLeagueLoading,
    setIsEventLoading,
    setCountryInBonusPopup,
    setOnlySportsSelected,
    setSportsSelectedInDialog,
    setEventsOpt,
    setNoLeaguesAvailable,
    setIsOddsByOutcomeLoading,
    setPersistedFormData
} = BoostedOddsSlice.actions

//DDL APIS //
export const getAllSportsByBrand = () => (dispatch) => {
    let url = boostedOddsApis.getAllSportsByBrand
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setSportByBrand(res.data))
        }
    })
}
export const getAllCountriesBySport = (sportsId, countryType) => (dispatch) => {
    dispatch(setNoLeaguesAvailable(true))
    let url = boostedOddsApis.getAllCountriesBySport(sportsId)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setCountryBySport(res.data))
            dispatch(setCountryInBonusPopup(res.data))
            dispatch(setCountryInBonus(res.data))
            dispatch(setIsCountriesLoading(false))
        }
    }).catch(() => {
        dispatch(setLeaguesInBonus([]))
        dispatch(setEventBySportCountryLeague([]))
        dispatch(setCountryInBonus([]))
        dispatch(setIsLeagueLoading(true))
        dispatch(setIsEventLoading(true))
        dispatch(setIsCountriesLoading(true))
    })
}

export const getLeaguesBysportAndCountry = (sportId, countryId) => (dispatch) => {
    dispatch(setNoLeaguesAvailable(true))
    const countryID = countryId || ""
    let url = boostedOddsApis.getLeaguesBysportAndCountry(sportId, countryID)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.msg === 'NO_LEAGUES_AVAILABLE_FOR_SELECTED_SPORT_AND_COUNTRY') {
            dispatch(setNoLeaguesAvailable(true))
        }
        if (res.status === 200) {
            dispatch(setLeagueBySportCountry(res.data))
            dispatch(setLeaguesInBonus(res.data))
            dispatch(setIsLeagueLoading(false))
            dispatch(setNoLeaguesAvailable(false))
        }
    }).catch(() => {
        dispatch(setLeaguesInBonus([]))
        dispatch(setEventBySportCountryLeague([]))
        dispatch(setIsLeagueLoading(true))
        dispatch(setIsEventLoading(true))
    })
}

export const getEventsBySportCountryLeague = (sport, country, league) => (dispatch) => {
    let url = boostedOddsApis.getEventsBySportCountryLeague(sport, country, league)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setEventBySportCountryLeague(res.data))
            dispatch(setIsEventLoading(false))
        }
    }).catch(() => {
        dispatch(setEventBySportCountryLeague([]))
        dispatch(setIsEventLoading(true))
    })
}

export const getAllMarketsByEvent = (eventId) => (dispatch) => {
    let url = boostedOddsApis.getAllMarketsByEvent(eventId)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setMarketByEvent(res.data))
        }
    }).catch(() => { })
}

export const getSubMarketByMarketEvent = (event, market) => (dispatch) => {
    let url = boostedOddsApis.getSubMarketByMarketEvent(event, market)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setSubMarket(res.data))
        }
    }).catch(() => { })
}

export const getOutcomesByMarketOrSubmarket = (event, market, subMarket) => (dispatch) => {
    let url = subMarket ? boostedOddsApis.getOutcomesByMarketOrSubmarket(event, market) + `&subMarketId=${subMarket}`
        : boostedOddsApis.getOutcomesByMarketOrSubmarket(event, market)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setOutComes(res.data))
        }
    }).catch(() => { })
}

// export const getOddsByOutcomeId = (event, market, outcome, subMarket) => (dispatch) => {
//     let url = subMarket ? boostedOddsApis.getOddsByOutcomeId(event, market) + `&subMarketId=${subMarket}&outComeId=${outcome}`
//         : boostedOddsApis.getOddsByOutcomeId(event, market) + `&outComeId=${outcome}`
//     apiCaller(url, "GET", {}).then((res) => {
//         if (res.status === 200) {
//             dispatch(setOddsByOutcome(res.data))
//         }
//     })
// }

export const getOddsByOutcomeId = (event, market, outcome, subMarket) => async (dispatch) => {
    let url = subMarket
        ? boostedOddsApis.getOddsByOutcomeId(event, market) + `&subMarketId=${subMarket}&outComeId=${outcome}`
        : boostedOddsApis.getOddsByOutcomeId(event, market) + `&outComeId=${outcome}`;

    dispatch(setOddsByOutcome({}));
    dispatch(setIsOddsByOutcomeLoading(true));

    try {
        const res = await apiCaller(url, "GET", {});
        if (res.status === 200) {
            dispatch(setOddsByOutcome(res.data));
            return res;
        }
    } catch {
        // handled silently
    } finally {
        dispatch(setIsOddsByOutcomeLoading(false));
    }
};

//DDL APIS //

//CREATE UPDATE APIS//
export const createBoostedOdds = (params) => (dispatch) => {
    let url = boostedOddsApis.createBoostedOdds
    apiCaller(url, "POST", params).then((res) => {
        if (res.status === 200) {
            toaster.success("SUCCESS")
            dispatch(boostedOddsSearchApi(null, 0, 25))
        }
    }).catch(() => toaster.error("FAILED"))
}

export const getAllBoostedOdds = (pageNum, itemsPerPage) => (dispatch) => {
    let url = boostedOddsApis.getAllBoostedOdds(pageNum, itemsPerPage)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setAllBoostedOdds(res.data))
        }
    })
}

export const updateBoostedOddsStatus = (params) => (dispatch) => {
    const url = boostedOddsApis.updateBoostedOddsStatus
    const obj = {
        id: params.id,
        status: params.status,
    };
    apiCaller(url, "PUT", obj)
        .then((res) => {
            toaster.success("SUCCESS")
            dispatch(boostedOddsSearchApi(null, 0, 25))
        })
        .catch((err) => toaster.error("FAILED"));
};

export const boostedOddsSearchApi = (param, pageNum, itemsPerPage) => (dispatch) => {
    let url = param ? boostedOddsApis.boostedOddsSearchApi + `?searchParam=${param}&pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
        : boostedOddsApis.boostedOddsSearchApi + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
    apiCaller(url, "POST", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setAllBoostedOdds(res.data))
            dispatch(setTotalRecord(res.totalRecords))
        }
    }).catch(() => { })
}

export const viewBoostedOddsUsers = (id) => (dispatch) => {
    let url = boostedOddsApis.viewBoostedOddsUsers(id)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setViewBoostedOddUser(res.data))
        }
    }).catch(() => { })
}

//CREATE UPDATE APIS//
export default BoostedOddsSlice.reducer